import React from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/uscgtoss/fields';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';
import {useFieldData} from 'components/forms/hooks';

const ShipmentDischarge = props => {
    //const vesselName = useFieldData('vessel_name');
    const fieldDict = fields;
    const sectionFields = [
        'department',
        'deck_position_served',
        'engine_position_served',
        'watertype',
        'also_polar',
        'date_reported',
        'date_detached',
    ];
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues({}, sectionFields, fieldDict);
    const [department, setDepartment] = useFieldData('department');
    const updateDepartment = e => {
        setDepartment(e.currentTarget.value);
    };

    const [watertype, setWatertype] = useFieldData('watertype');

    const updateWatertype = e => {
        setWatertype(e.target.value);
    };

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                Dates
            </Typography>
            <Typography variant='body1' align='left'>
                Now let's enter your service on this vessel, starting with the first
                line.
            </Typography>
            <AutoField
                field={fields['department']}
                name='department'
                onChange={updateDepartment}
            />
            {department === 'Deck' && (
                <AutoField
                    field={fields['deck_position_served']}
                    name='deck_position_served'
                />
            )}
            {department === 'Engine' && (
                <AutoField
                    field={fields['engine_position_served']}
                    name='engine_position_served'
                />
            )}

            <Typography variant='body1' align='left'>
                Enter the start/end dates of for this period of sea service.
            </Typography>
            <AutoField field={fields['date_reported']} name='date_reported' />
            <AutoField field={fields['date_detached']} name='date_detached' />
            <Typography variant='body1' align='left'>
                We know route is not on your TOSS but it makes your life easier if
                you select where you were working while underway.
            </Typography>
            <AutoField
                field={fields['watertype']}
                name='watertype'
                onChange={updateWatertype}
            />
            {(watertype === 'Oceans' ||
                watertype === 'Near Coastal' ||
                watertype === 'Inland') && (
                <AutoField field={fields['also_polar']} name='also_polar' />
            )}

            <Typography variant='body1' align='left'>
                Don't worry if you have several records on the same vessel on your
                letter - you'll have an opportunity to enter each one.
            </Typography>
            {props.children}
        </Section>
    );
};

export default ShipmentDischarge;
